import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Exact checkmark glyph exported from the Figma "Verify-Asset" file (35x35
 * viewBox) — replaces MUI's stock CheckCircle icon, which has a different
 * circle-to-bounding-box ratio and doesn't match the design pixel-for-pixel.
 */
export function DetectedCheckIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 35 35">
      <path d="M17.5 3.88892C9.98669 3.88892 3.88892 9.98669 3.88892 17.5C3.88892 25.0134 9.98669 31.1111 17.5 31.1111C25.0134 31.1111 31.1111 25.0134 31.1111 17.5C31.1111 9.98669 25.0134 3.88892 17.5 3.88892ZM15.7986 21.6463L11.5452 17.3928L12.7446 16.1934L15.7986 19.2388L22.2554 12.7821L23.4549 13.9901L15.7986 21.6463Z" />
    </SvgIcon>
  );
}
